/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldTypeEnum } from './FieldTypeEnum';
import { FieldTypeEnumFromJSON, FieldTypeEnumFromJSONTyped, FieldTypeEnumToJSON } from './FieldTypeEnum';
import type { TargetModelEnum } from './TargetModelEnum';
import { TargetModelEnumFromJSON, TargetModelEnumFromJSONTyped, TargetModelEnumToJSON } from './TargetModelEnum';

/**
 * Read-only serializer for custom field definitions. Used by frontend to display fields.
 * @export
 * @interface CustomFieldDefinition
 */
export interface CustomFieldDefinition {
  /**
   *
   * @type {number}
   * @memberof CustomFieldDefinition
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDefinition
   */
  readonly name: string;
  /**
   *
   * @type {FieldTypeEnum}
   * @memberof CustomFieldDefinition
   */
  readonly fieldType: FieldTypeEnum;
  /**
   *
   * @type {TargetModelEnum}
   * @memberof CustomFieldDefinition
   */
  readonly targetModel: TargetModelEnum;
  /**
   *
   * @type {number}
   * @memberof CustomFieldDefinition
   */
  readonly order: number;
  /**
   *
   * @type {boolean}
   * @memberof CustomFieldDefinition
   */
  readonly required: boolean;
}

/**
 * Check if a given object implements the CustomFieldDefinition interface.
 */
export function instanceOfCustomFieldDefinition(value: object): value is CustomFieldDefinition {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('fieldType' in value) || value['fieldType'] === undefined) return false;
  if (!('targetModel' in value) || value['targetModel'] === undefined) return false;
  if (!('order' in value) || value['order'] === undefined) return false;
  if (!('required' in value) || value['required'] === undefined) return false;
  return true;
}

export function CustomFieldDefinitionFromJSON(json: any): CustomFieldDefinition {
  return CustomFieldDefinitionFromJSONTyped(json, false);
}

export function CustomFieldDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomFieldDefinition {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    fieldType: FieldTypeEnumFromJSON(json['field_type']),
    targetModel: TargetModelEnumFromJSON(json['target_model']),
    order: json['order'],
    required: json['required'],
  };
}

export function CustomFieldDefinitionToJSON(
  value?: Omit<CustomFieldDefinition, 'id' | 'name' | 'fieldType' | 'targetModel' | 'order' | 'required'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
